var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}${_vm.slug}`,"viewBox":"0 0 20 20"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 20C15.5229 20 20 15.5229 20 10C20 4.47714 15.5229 0 10 0C4.47705 0 0 4.47714 0 10C0 15.5229 4.47705 20 10 20ZM15 9H5V11H15V9Z","fill":_vm.getColor('main')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }